import React from 'react';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../../auth/RutaAutenticada';
import * as Roles from '../DeclaracionRoles';
import Documentos from './Documentos';
import AddDocumentos from './AddDocumentos';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/listar`}
              component={Documentos}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/agregar`}
              component={AddDocumentos}
              rolesAutorizados={[
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

export default Index;
